import React, { useState, useEffect, useCallback } from "react";
import { format } from "date-fns";
import { getVendorHistoryApi } from "./vendor_api";
import { ReactComponent as HisEmailIC } from "../../assets/svg/his_Email_ic.svg";
import { ReactComponent as HisAttachIc } from "../../assets/svg/his_attach_ic.svg";
import { ReactComponent as HisStatusIc } from "../../assets/svg/his_status_ic.svg";
import { ReactComponent as HisEditIc } from "../../assets/svg/his_edit_ic.svg";
import { ReactComponent as HisContIC } from "../../assets/svg/his_cont_ic.svg";
import "./vendorView.css";
import { getApi } from "../../services/http-clients";

const HistoryTab = ({ vendorId }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [histories, setHistories] = useState([]);
  const [search, setSearch] = useState("");
  const [dateRange, setDateRange] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [formattedDate, setFormattedDate] = useState("");

  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);

  const getHistoryList = async () => {
    const start = dateRange?.start;
    const end = dateRange?.end;

    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search,
      from_date: start ? format(start, "yyyy-MM-dd") : null,
      to_date: end ? format(end, "yyyy-MM-dd") : null,
    };

    try {
      const data = await getApi(`${apiUrl}vendor/history/${vendorId}`, param);
      if (data?.success) {
        setHistories(data.histories || []);
        setTotalCount(data.total_rec || 0);
        setPageCount(data.total_pgs || 0);
        setFormattedDate("");
        if (data.histories?.length > 0 && data.histories[0].date) {
          const cleanedDate = data.histories[0].date.replace(" at ", " ");
          const dateObj = new Date(cleanedDate);

          if (!isNaN(dateObj)) {
            setFormattedDate(
              dateObj.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              }),
            );
          }
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getHistoryList();
  }, [itemsPerPage, itemOffset, search, dateRange]);

  const getCleanType = (type) => {
    if (!type) return "";
    return type.trim().toLowerCase().split(" ")[0];
  };
  const historyIcons = {
    attachment: <HisAttachIc />,
    status: <HisStatusIc />,
    stage: <HisStatusIc />,
    vendor: <HisEditIc />,
    new: <HisContIC />,
    email: <HisEmailIC />,
  };
  return (
    <div>
      <h5 className="fw-semibold mb-1">History</h5>
      <div className=" py-4" style={{ overflowX: "auto" }}>
        <div style={{ overflowX: "auto" }}>
          <div style={{ minWidth: "300px" }}>
            <div className="position-relative text-center mb-4">
              <hr />
              <span
                className="position-absolute top-50  start-50 translate-middle px-4 py-1 text-muted small border rounded-pill"
                style={{
                  fontWeight: 700,
                  fontSize: "13px",
                  backgroundColor: "#F5F7FF",
                  color: "#172B4D",
                }}
              >
                {formattedDate}
              </span>
            </div>
            {histories?.length === 0 ? (
              <div className="text-center py-5 text-muted">
                <p className="fs-16 fw-500 mb-1">No history records found</p>
                <span className="fs-13 fw-400">All stage updates, status changes, and record modifications are tracked here.</span>
              </div>
            ) : (
              histories?.map((HistoryItem, index) => {
                // const iconKey = getCleanType(HistoryItem.title);
                // const Icon = historyIcons[iconKey] || historyIcons["note"]; // fallback icon
                const Icon = <HisStatusIc />; // fallback icon

                return (
                  <div key={index} className="d-flex align-items-start">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "start",
                        marginRight: "1rem",
                        position: "relative",
                      }}
                    >
                      <div
                        className="fs-13 fw-500 textdrkColor mt-1 mb-1"
                        style={{ marginRight: "1rem" }}
                      >
                        {HistoryItem?.date?.includes(" at ")
                          ? HistoryItem.date.split(" at ")[1]
                          : ""}
                      </div>

                      <div
                        style={{
                          position: "relative",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #dee2e6",
                            borderRadius: "50%",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1,
                          }}
                        >
                          {Icon}
                        </div>

                        {index !== histories?.length - 1 && (
                          <div
                            style={{
                              width: "2px",
                              height: "90px",
                              border: "1px dashed #D3D8E0",
                            }}
                          />
                        )}
                      </div>
                    </div>

                    <div style={{ flex: 1 }}>
                      <p className="mb-1">
                        <strong className="fs-14 fw-600 textcolor">
                          {HistoryItem.title}
                        </strong>
                        {HistoryItem.link ? (
                          <span style={{ color: "#3D4AF5" }}>
                            -{HistoryItem.link}
                          </span>
                        ) : (
                          <span
                            className="fs-14 fw-500 cardTextBlue"
                            style={{ whiteSpace: "pre-wrap" }}
                          >
                            {" "}
                            - {HistoryItem.description}
                          </span>
                        )}
                      </p>
                      <div className="fs-13 fw-500 cardTextGrey">
                        By {HistoryItem.emp_name} on{" "}
                        {HistoryItem?.date?.includes(" at ")
                          ? HistoryItem.date.split(" at ")[0]
                          : ""}
                      </div>
                    </div>
                  </div>
                );
              })
            )}

            {isLoading && (
              <div style={{ textAlign: "center", padding: "10px" }}>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span style={{ marginLeft: "8px" }}>Loading more notes...</span>
              </div>
            )}
            {!hasMore && !isLoading && (
              <p style={{ textAlign: "center" }}>No more notes.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryTab;
